import styled from 'styled-components'
import { Modal, WorkspaceLogo } from '@sketch/components'

interface HeaderProps {
  url: string
}

export const Header = styled.div<HeaderProps>`
  margin: -20px -20px 0px;
  height: 200px;
  padding: 20px 0 0;
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  overflow: hidden;

  background-color: rgba(85, 93, 255, 0.04);
  background-image: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.27) 0%,
    rgba(255, 255, 255, 0.31) 100%
  );

  ::after {
    z-index: -1;
    position: absolute;
    content: '';
    inset: 0;

    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    filter: blur(40px);
    background-image: url(${({ url }) => url});
  }
`

export const ModalBody = styled(Modal.Body)`
  && {
    padding-top: 0;
  }
`

export const ArrowIconWrapper = styled.div`
  flex-shrink: 0;
  width: 29px;
  height: 29px;
  padding: 6px; /* stylelint-disable-line scales/space */
  color: white;
  border-radius: 15px; /* stylelint-disable-line scales/radii */
  background: ${({ theme }) => theme.colors.background.tertiary.B};
`

export const InlineWorkspaceLogo = styled(WorkspaceLogo)`
  width: 16px;
  height: 16px;
  margin-top: -1px; /* stylelint-disable-line scales/space */

  display: inline-block;
  vertical-align: middle;
`
